import { TableHeader } from "../../commons";
import SopModuleTableData from "./SopModuleTableData";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { AuditSessionListType } from "../../../redux/fixedAsset/fixedAssetRegisterTypes";
import ScrollToTop from "../../commons/ScrollToTop";
import InfiniteLoader from "../../commons/InfiniteLoader/InfiniteLoader";
type AppProps = {
  fetching: boolean;
  tableHeaders: TableHeadersType[] | [];
  data: AuditSessionListType[] | [];
  history: any;
  offset: number;
  type:string;
  handleDelete?: (id: string) => void;
  isSOPEditPresent?: boolean;
  isSOPDeletePresent?: boolean;
  handleHideSop?:(data:any)=>void;
  handleUnHideSop?:(data:any)=>void;
  hideSOPPresent?:boolean|undefined;
};
const SopModuleTable = ({
  tableHeaders,
  fetching,
  data,
  history,
  offset,
  type,
  handleDelete,
  isSOPEditPresent,
  isSOPDeletePresent,
  handleHideSop,
  handleUnHideSop,
  hideSOPPresent
}: AppProps) => {
  return (
    <>
      <div className="jobsType">
        <table className="table thead-light table-bordered">
          <thead className="text-start sticky-table-header">
            <TableHeader tableHeader={tableHeaders} />
          </thead>
          <tbody>
            <SopModuleTableData
              tableHeaders={tableHeaders}
              data={data}
              history={history}
              type={type}
              handleDelete={handleDelete}
              isSOPEditPresent={isSOPEditPresent}
              isSOPDeletePresent={isSOPDeletePresent}
              handleHideSop={handleHideSop}
              handleUnHideSop={handleUnHideSop}
              hideSOPPresent={hideSOPPresent}
            />
            {fetching && offset > 0 && <div>{<InfiniteLoader />}</div>}
            <div style={{ display: fetching ? "none" : "inline" }}>
              <ScrollToTop />
            </div>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default SopModuleTable;
